import {
  GlobalMessages,
  TranslationGlobalMessages
} from "../interfaces/globalMessages";

export const messages: TranslationGlobalMessages = {
  [GlobalMessages.activeText]: "Activo",
  [GlobalMessages.inactiveText]: "Inactivo",
  [GlobalMessages.yesText]: "Sí",
  [GlobalMessages.noText]: "No",
  [GlobalMessages.filtersText]: "Filtros",
  [GlobalMessages.underConstructionText]: "En construcción",
  [GlobalMessages.columnActions]: "Acciones",
  [GlobalMessages.buttonAdd]: "Añadir nuevo",
  [GlobalMessages.buttonEdit]: "Editar",
  [GlobalMessages.buttonDelete]: "Eliminar",
  [GlobalMessages.buttonRefresh]: "Refrescar",
  [GlobalMessages.buttonClose]: "Cerrar",
  [GlobalMessages.buttonPrint]: "Imprimir",
  [GlobalMessages.buttonExport]: "Exportar",
  [GlobalMessages.buttonCancel]: "Cancelar",
  [GlobalMessages.buttonAccept]: "Aceptar",
  [GlobalMessages.buttonReject]: "Rechazar",
  [GlobalMessages.buttonSaveChanges]: "Guardar cambios",
  [GlobalMessages.buttonView]: "Ver",
  [GlobalMessages.buttonHelp]: "Ayuda",
  [GlobalMessages.tooltipFixed]:
    "Los registros fijos (predefinidos) no se pueden manipular",
  [GlobalMessages.noItemsText]: "No hay elementos para mostrar",
  [GlobalMessages.clientSelectInstruction]: "Introduzca al menos 3 caracteres",
  [GlobalMessages.entityClassificationSupplyType]:
    "Clasificación de tipo de suministro",
  [GlobalMessages.entityConcreteBatchingPlant]: "Planta de acero concreto",
  [GlobalMessages.entityMeasureUnitType]: "Tipo de unidad de medida",
  [GlobalMessages.entitySupplier]: "Proveedor",
  [GlobalMessages.entityConcreteCharacteristicsType]: "Tipo de características",
  [GlobalMessages.entityGravel]: "Grava",
  [GlobalMessages.entitySlump]: "Slump",
  [GlobalMessages.entityConcreteRecipeFamilyApplicationType]:
    "Tipo de aplicación familiar de recetas de concreto",
  [GlobalMessages.invalidFormInputs]:
    "Complete todas las informaciones obligatorias de la pestaña actual",
  [GlobalMessages.invalidMinEffectiveDate]:
    "La fecha debe ser mayor o igual a la fecha efectiva activa",
  [GlobalMessages.measureUnitCharacteristicMPa]: "MPa",
  [GlobalMessages.emptySelectField]: "Ninguno",
  [GlobalMessages.selectClient]: "Seleccione el cliente",
  [GlobalMessages.dayDeliveryText]: "Últimas entregas del día",
  [GlobalMessages.lastConcretingRequestsText]:
    "Últimas solicitudes de hormigonado",
  [GlobalMessages.lastContractsText]: "Últimos contratos",
  [GlobalMessages.searchText]: "Buscar",
  [GlobalMessages.showMore]: "Mostrar más",
  [GlobalMessages.reversibleAction]: "Esta acción se puede revertir más tarde",
  [GlobalMessages.successText]: "Éxito",
  [GlobalMessages.warningText]: "Aviso",
  [GlobalMessages.errorText]: "Error",
  [GlobalMessages.lgpdTitle]: "Término de intercambio de datos"
};
